import { render, staticRenderFns } from "./viewSalesman.vue?vue&type=template&id=281f10cd&scoped=true&"
import script from "./viewSalesman.vue?vue&type=script&lang=js&"
export * from "./viewSalesman.vue?vue&type=script&lang=js&"
import style0 from "./viewSalesman.vue?vue&type=style&index=0&id=281f10cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f10cd",
  null
  
)

export default component.exports